/* CanaryFun theme — cart drawer (Shopify AJAX), menu, reveal, accordions */
(function () {
  "use strict";
  var money = function (cents) {
    return "€" + (cents / 100).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 7h13l-1.2 9.5a2 2 0 0 1-2 1.75H8.6a2 2 0 0 1-2-1.74L5 4H3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function el(sel, root) { return (root || document).querySelector(sel); }
  function openCart() { var d = el("[data-cart-drawer]"); if (d) { d.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeCart() { var d = el("[data-cart-drawer]"); if (d) { d.classList.remove("open"); document.body.style.overflow = ""; } }
  function openMenu() { var m = el("[data-mobile-nav]"); if (m) { m.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeMenu() { var m = el("[data-mobile-nav]"); if (m) { m.classList.remove("open"); document.body.style.overflow = ""; } }

  function updateCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (e) { e.textContent = n; e.hidden = n === 0; });
  }

  function lineHTML(it) {
    var img = it.image ? it.image.replace(/(_\d+x\d+)?(\.[a-z]+)(\?.*)?$/i, "_200x$2") : "";
    return '<div class="cart-line" data-key="' + it.key + '">' +
      '<a class="th" href="' + it.url + '">' + (img ? '<img class="art-img" src="' + img + '" alt="">' : '') + '</a>' +
      '<div><div class="ci-t">' + it.product_title + '</div>' +
      '<div class="ci-v">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "") + '</div>' +
      '<div class="ci-controls"><div class="miniqty">' +
      '<button data-qd="' + it.key + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-qi="' + it.key + '" aria-label="Increase">+</button>' +
      '</div><button class="rm" data-rm="' + it.key + '">Remove</button></div></div>' +
      '<div class="ci-p">' + money(it.line_price) + '</div></div>';
  }

  function render(cart) {
    updateCount(cart.item_count);
    var body = el("[data-cart-body]"), foot = el("[data-cart-foot]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="ic">' + CART_SVG + '</div>' +
        '<h3 style="font-family:var(--serif);font-size:1.3rem">Your cart is empty</h3>' +
        '<p class="muted" style="margin:8px 0 20px;font-size:.92rem">Find a piece of the islands to take home.</p>' +
        '<a class="btn btn-primary" href="/collections/all" data-cart-close>Browse the gallery</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHTML).join("");
    if (foot) { foot.hidden = false; var s = foot.querySelector("[data-subtotal]"); if (s) s.textContent = money(cart.total_price); }
  }

  function refresh(open) {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (open) openCart(); return cart; });
  }

  function change(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function add(form) {
    var data = new FormData(form);
    return fetch("/cart/add.js", { method: "POST", body: data, headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(true); });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); refresh(true); }
    if (e.target.closest("[data-cart-close]")) { closeCart(); }
    if (e.target.closest("[data-menu-open]")) openMenu();
    if (e.target.closest("[data-menu-close]")) closeMenu();
    var qd = e.target.closest("[data-qd]"), qi = e.target.closest("[data-qi]"), rm = e.target.closest("[data-rm]");
    if (qd || qi || rm) {
      var line = e.target.closest(".cart-line");
      var key = (qd || qi || rm).getAttribute(qd ? "data-qd" : qi ? "data-qi" : "data-rm");
      var span = line ? line.querySelector(".miniqty span") : null;
      var cur = span ? parseInt(span.textContent, 10) : 1;
      change(key, rm ? 0 : Math.max(0, cur + (qd ? -1 : 1)));
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeMenu(); } });

  document.addEventListener("submit", function (e) {
    var f = e.target.closest("form");
    if (f && (f.id === "cf-add-form" || (f.getAttribute("action") || "").indexOf("/cart/add") > -1)) {
      e.preventDefault(); add(f);
    }
  });

  // reveal on scroll
  function reveal(root) {
    if (!("IntersectionObserver" in window)) { (root || document).querySelectorAll(".reveal").forEach(function (x) { x.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
    (root || document).querySelectorAll(".reveal:not(.in)").forEach(function (x) { io.observe(x); });
  }

  // accordions
  function accordions(root) {
    (root || document).querySelectorAll(".acc-q").forEach(function (q) {
      if (q.dataset.bound) return; q.dataset.bound = "1";
      q.addEventListener("click", function () {
        var it = q.closest(".acc-item"), a = it.querySelector(".acc-a");
        var open = it.classList.toggle("open");
        a.style.maxHeight = open ? a.querySelector(".inner").scrollHeight + 40 + "px" : "0";
      });
    });
  }

  // infinite scroll for collection grids — auto-loads the next page on scroll.
  // The server-rendered "Load more" button is the no-JS fallback; with JS we
  // replace it with a thin sentinel/loader so there's no button to click.
  function infiniteScroll() {
    var grid = document.getElementById("cf-grid");
    var btn = document.getElementById("cf-load-more");
    if (!grid || !btn) return;
    var wrap = btn.closest(".load-more") || btn.parentNode;
    var nextUrl = btn.getAttribute("data-next-url");
    if (!("IntersectionObserver" in window) || !nextUrl) return; // keep the real button as fallback
    wrap.innerHTML = '<div class="cf-sentinel" style="min-height:1px;width:100%"></div><div class="cf-loading muted" style="display:none;font-family:var(--mono);font-size:.78rem;letter-spacing:.04em">Loading more works…</div>';
    var sentinel = wrap.querySelector(".cf-sentinel");
    var loadingEl = wrap.querySelector(".cf-loading");
    var loading = false, done = false;
    function loadNext() {
      if (!nextUrl || loading || done) return;
      loading = true; loadingEl.style.display = "block";
      fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        doc.querySelectorAll("#cf-grid .pcard").forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        reveal(grid);
        var nb = doc.getElementById("cf-load-more");
        nextUrl = nb ? nb.getAttribute("data-next-url") : null;
        loading = false; loadingEl.style.display = "none";
        if (!nextUrl) { done = true; io.disconnect(); if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
      }).catch(function () { loading = false; loadingEl.style.display = "none"; });
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) loadNext(); });
    }, { rootMargin: "500px 0px" });
    io.observe(sentinel);
  }

  function boot() { reveal(document); accordions(document); infiniteScroll(); refresh(false); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
